<div class="modal" *ngIf="memberToDelete">
    <div class="header">
        <h1 class="title" translate [translateParams]="{ email: memberToDelete.username }">
            PREMIUM_ADMIN_MEMBER_MODAL_DELETE_MEMBER_TITLE</h1>
    </div>
    <div class="body">
        <ng-container *ngIf="(memberDeleting$ | async); else notInactivatingMember">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #notInactivatingMember>
            <div class="section">
                <div class="description" translate [translateParams]="{ email: memberToDelete.username }">
                    PREMIUM_ADMIN_MEMBER_MODAL_DELETE_MEMBER_DESCRIPTION
                </div>
                <div class="description">
                    {{'PREMIUM_ADMIN_MEMBER_MODAL_DELETE_MEMBER_QUESTION_CONFIRMATION' | translate}}
                </div>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" (click)="closeModal()" [disabled]="(memberDeleting$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_TEAM_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" (click)="deleteMember()" [disabled]="(memberDeleting$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_DELETE_MEMBER_BUTTON_LABEL_DELETE_MEMBER</button>
    </div>
</div>